// Per-device lights popover, used on /labs/ slot cards and the device
// connect page. Opens a Dialog listing the device's lights with toggles.
// Any logged-in user can toggle on/off; admins can add/remove links.

(function ($) {
  'use strict';

  var current = { dlg: null, deviceId: null };

  function paintToggle($btn, state) {
    var $knob = $btn.find('.light-pop-knob');
    $btn.removeClass('bg-emerald-500 bg-slate-300 dark:bg-slate-600 bg-amber-400');
    $knob.removeClass('translate-x-0.5 translate-x-5');
    if (state === 'on') {
      $btn.addClass('bg-emerald-500');
      $knob.addClass('translate-x-5');
    } else if (state === 'off') {
      $btn.addClass('bg-slate-300 dark:bg-slate-600');
      $knob.addClass('translate-x-0.5');
    } else {
      $btn.addClass('bg-amber-400');
      $knob.addClass('translate-x-0.5');
    }
  }

  function open(deviceId, html) {
    current.deviceId = deviceId;
    var dlg = new Dialog('Lights', html, { size: 'lg' });
    dlg.setButtons([{ name: 'Close', dismiss: true }]).show();
    current.dlg = dlg;
  }

  function openModal(deviceId) {
    $.get('/api/devices/' + deviceId + '/lights/', function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      open(deviceId, resp.html);
    }).fail(function (xhr) {
      Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Failed to load lights', 'error');
    });
  }

  // Highlight a single-light button based on its state.
  function paintButton($btn, state) {
    var $icon = $btn.find('.lab-light-icon');
    if (state === 'on') {
      $icon.addClass('text-amber-500 dark:text-amber-400').removeClass('text-slate-400 dark:text-zinc-500');
      $btn.addClass('bg-amber-50 dark:bg-amber-500/10');
    } else {
      $icon.addClass('text-slate-400 dark:text-zinc-500').removeClass('text-amber-500 dark:text-amber-400');
      $btn.removeClass('bg-amber-50 dark:bg-amber-500/10');
    }
  }

  // ---------- Click the Light button ----------
  $(document).on('click', '.lab-light-btn', function () {
    var $btn = $(this);
    var deviceId = $btn.data('device-id');
    var count = parseInt($btn.data('light-count'), 10) || 0;
    var singleId = $btn.data('single-light-id');

    if (count === 0) {
      // No lights — admins open the modal to add one. (Users never see this
      // button when there are no lights.)
      openModal(deviceId);
      return;
    }
    if (count === 1 && singleId) {
      // Exactly one light — toggle it directly, no modal.
      $.post('/api/lights/' + singleId + '/toggle/')
        .done(function (r) {
          if (r.ok) {
            paintButton($btn, r.state);
            Toast.show('Light ' + r.state, 'success');
          } else {
            Toast.show(r.error || 'Failed', 'error');
          }
        })
        .fail(function (xhr) {
          Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
        });
      return;
    }
    // 2+ lights — open the modal with per-light toggles.
    openModal(deviceId);
  });

  // ---------- Admin quick-remove (✕ on the button) ----------
  $(document).on('click', '.lab-light-remove-btn', function (e) {
    e.stopPropagation();   // don't trigger the toggle on the button behind it
    var $btn = $(this);
    var deviceId = $btn.data('device-id');
    var count = parseInt($btn.data('light-count'), 10) || 0;
    var singleId = $btn.data('single-light-id');

    if (count === 1 && singleId) {
      // One light — unlink it directly.
      $.post('/api/lights/' + singleId + '/unlink/', { device_id: deviceId })
        .done(function (r) {
          if (r.ok) {
            Toast.show('Light removed', 'success');
            location.reload();
          } else {
            Toast.show(r.error || 'Failed', 'error');
          }
        })
        .fail(function (xhr) {
          Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
        });
    } else {
      // Multiple lights — open the modal so the admin picks which to remove.
      openModal(deviceId);
    }
  });

  // ---------- Reflect current state on single-light buttons ----------
  // On page load, fetch state for each single-light button so the bulb is
  // colored correctly (amber=on, gray=off).
  $('.lab-light-btn[data-light-count="1"]').each(function () {
    var $btn = $(this);
    var singleId = $btn.data('single-light-id');
    if (!singleId) return;
    $.get('/api/devices/' + $btn.data('device-id') + '/lights/', function (resp) {
      if (!resp.ok || !resp.html) return;
      var $row = $(resp.html).find('.light-popover-row').first();
      var on = $row.find('.light-pop-toggle').hasClass('bg-emerald-500');
      paintButton($btn, on ? 'on' : 'off');
    });
  });

  // ---------- Toggle a light (any user) ----------
  $(document).on('click', '.light-pop-toggle', function () {
    var $btn = $(this);
    var id = $btn.closest('.light-popover-row').data('id');
    $.post('/api/lights/' + id + '/toggle/')
      .done(function (r) {
        if (r.ok) {
          paintToggle($btn, r.state);
        } else {
          Toast.show(r.error || 'Failed', 'error');
        }
      })
      .fail(function (xhr) {
        Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
      });
  });

  // ---------- Add a light to the device (admin) ----------
  $(document).on('click', '.light-pop-add', function () {
    var $sel = $(this).closest('div').find('.light-pop-select');
    var lightId = $sel.val();
    if (!lightId) { Toast.show('Pick a light', 'error'); return; }
    $.post('/api/devices/' + current.deviceId + '/lights/link/', { light_id: lightId })
      .done(function (r) {
        if (r.ok) {
          Toast.show('Light added', 'success');
          // The page button's light-count/single-id are now stale — reload so
          // the slot/connect button re-renders with the new state.
          location.reload();
        } else {
          Toast.show(r.error || 'Failed', 'error');
        }
      })
      .fail(function (xhr) {
        Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
      });
  });

  // ---------- Remove a light from the device (admin) ----------
  $(document).on('click', '.light-pop-unlink', function () {
    var id = $(this).closest('.light-popover-row').data('id');
    $.post('/api/lights/' + id + '/unlink/', { device_id: current.deviceId })
      .done(function (r) {
        if (r.ok) {
          Toast.show('Light removed', 'success');
          location.reload();
        } else {
          Toast.show(r.error || 'Failed', 'error');
        }
      })
      .fail(function (xhr) {
        Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
      });
  });

})(jQuery);
